// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { CategoryFieldSuggestionsValue } from "@coveo/headless";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Product } from "@coveo/headless/commerce";
import useWindowSize from "@DSG/Common/Hooks/useWindowSize";
import Button from "@DSG/MobiusOverrides/Button/Button";
import Popover, { PositionStyle } from "@DSG/MobiusOverrides/Popover/Popover";
import colorPallete, { bodyFonts, elevation, labelFonts } from "@DSG/MobiusOverrides/styles/variables";
import { getSettingsCollection } from "@DSG/Overrides/Store/Context/ContextSelectors";
import CoveoApplicationState from "@DSG/Store/Data/CoveoApplicationState/CoveoApplicationState";
import { DISPATCH_ISLOADING_UI_STATE, DISPATCH_SET_SEARCH_INPUT_QUERY } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import CoveoAutocompleteProducts from "@DSG/Widgets/Coveo/Header/CoveoAutocompleteProducts";
import CoveoSearchBrands from "@DSG/Widgets/Coveo/Header/CoveoSearchBrands";
import CoveoSearchHistory from "@DSG/Widgets/Coveo/Header/CoveoSearchHistory";
import { CoveoSearchInputStyles } from "@DSG/Widgets/Coveo/Header/CoveoSearchInput";
import CoveoSearchSuggestions from "@DSG/Widgets/Coveo/Header/CoveoSearchSuggestions";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSearchHistory, SearchHistoryItem } from "@insite/client-framework/Services/AutocompleteService";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { AutocompleteProductsStyles } from "@insite/content-library/Widgets/Header/AutocompleteProducts";
import { SearchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { FormFieldSizeVariant } from "@insite/mobius/FormField";
import { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Hidden } from "@insite/mobius/index";
import { ContentBodyProps, OverflowWrapperProps, PopoverPresentationProps } from "@insite/mobius/Popover";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import throttle from "lodash/throttle";
import React, { ReactElement, RefObject, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { css } from "styled-components";

export interface CoveoSearchPopoverStyles {
    popover?: PopoverPresentationProps;
    popoverQuery?: InjectableCss;
    popoverWrapper?: OverflowWrapperProps;
    popoverContentBody?: ContentBodyProps;
    closeButton?: InjectableCss;
    cancelButton?: InjectableCss;
    searchContent?: InjectableCss;
    autocompleteWrapper?: InjectableCss;
    autocompleteColumnWrapper?: InjectableCss;
    searchHistoryStyles?: SearchHistoryStyles;
    autocompleteProductsStyles?: AutocompleteProductsStyles;
    leftColumnWrapper?: InjectableCss;
    rightColumnWrapper?: InjectableCss;
    bottomWrapper?: InjectableCss;
}
interface OwnProps {
    closeAutocomplete: () => void;
    extendedStyles?: SearchHistoryStyles;
}

const mapStateToProps = (state: CoveoApplicationState) => ({
    coveoCommerce: state.DSGGlobalData,
    session: state.context.session,
    searchHistoryEnabled: getSettingsCollection(state).searchSettings.searchHistoryEnabled,
});

export const coveoSearchPopoverStyles: CoveoSearchPopoverStyles = {
    popover: {
        transitionDuration: "regular",
        toggle: false,
    },
    popoverWrapper: {
        as: "div",
        _height: "auto",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    &.activePopover {
                        position: fixed;
                        width: 100%;
                        background: ${colorPallete.white};
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 999;
                        display: block;
                        min-height: 100%;
                        overflow: hidden;
                        overflow-y: auto;
                        [class*="PopoverStyle"] {
                            overflow: initial;
                            position: initial !important;
                            min-height: initial;
                            width: 100%;
                            height: calc(100% - 88px);
                            max-height: initial;
                            padding: 0;
                            margin: 0;
                            top: auto !important;
                            box-shadow: none;
                        }
                        input {
                            &:not(.react-datetime-picker__inputGroup__input) {
                                &[class*="Input"] {
                                    font-size: ${bodyFonts.body1RegularLg.fontSize};
                                    line-height: ${bodyFonts.body1RegularLg.lineHeight};
                                    padding-right: 6px;
                                }
                            }
                        }
                        .cancelButtonPopover {
                            display: block;
                        }
                        [class*="FormFieldStyle-"] {
                            padding: 24px 88px 23px 24px;
                            background: ${colorPallete.grey600DisabledText};
                            border-bottom: 1px solid ${colorPallete.grey800};
                        }
                    }
                `,
            ], "max")}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                null,
                css`
                    &.activePopover {
                        z-index: 9999;
                    }
                `,
            ], "min")}
            @media screen and (min-width: 1024px) and (max-width: 1140px) {
                [class*="PopoverStyle"]:not(:empty) {
                    right: -70px !important;
                }
            }
        
        `
    },
    popoverContentBody: {
        as: "div",
        _height: "100%",
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        &:not(:empty) {
                            max-width: initial;
                            min-height: initial;
                            width: auto;
                            height: auto;
                            overflow: initial;
                            margin-top: 9px;
                            background: transparent;
                            box-shadow: none;
                            top: 48px !important;
                            position: absolute !important;
                            right: 0 !important;
                        }
                    `,
                ],
                "min",
            )}
        `
    },
    closeButton: {
        css: css`
            &,
            &:not(:disabled),
            &:hover,
            &:focus,
            &:active {
                padding: 0;
                min-height: initial;
                border: none;
                background: transparent;
                position: absolute;
                right: 72px;
                top: 8px;
              
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        right: 144px;
                        top: 32px;
                        svg {
                            width: 24px;
                            height: 24px;
                        }
                    `,
                ], "max")}

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        z-index: 999;
                    `,
                ], "min")}
            }
        `
    },
    cancelButton: {
        css: css`
            &,
            &:not(:disabled),
            &:hover,
            &:focus,
            &:active {
                padding: 0;
                min-height: initial;
                border: none;
                background: transparent;
                position: absolute;
                right: 24px;
                top: 35px;
            }
            & {
                span {
                    color: ${colorPallete.white};
                    text-decoration: underline;
                    font: ${labelFonts.label1SemiBold.fontWeight} ${labelFonts.label1SemiBold.fontSize}/${labelFonts.label1SemiBold.lineHeight} ${labelFonts.label1SemiBold.fontFamily};
                }
              
            }
        `
    },
    searchContent: {
        css: css`
            padding: 16px 3px;
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`    
                        flex-direction: column;
                    `,
                ],
                "max",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        &:not(:empty) {
                            min-height: initial;
                            max-width: 768px;
                            width: 768px;
                            background: ${colorPallete.white};
                            box-shadow: ${elevation.dp08};
                            border: 1px solid ${colorPallete.grey600DisabledText};
                            border-radius: 0 0 8px 8px;
                            padding: 16px 24px;
                        }
                        .leftColumnWrapper:empty + .rightColumnWrapper {
                            width: 100%;
                            max-width: 100%;
                            padding: 0;
                        }
                    `,
                ],
                "min",
            )}
        `
    },
    leftColumnWrapper: {
        css: css`
            margin: 0 13px;
            width: calc(100% - 26px);
            border: 1px solid ${colorPallete.grey300};
            border-radius: 8px;
            padding: 16px;
            display: flex;
            flex-direction: column;
            gap: 16px;
            &:empty {
                display: none;
                border: none;
                padding: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`    
                        max-width: 240px;
                        width: 100%;
                        margin: 1px 0 0;
                        width: 100%;
                        padding: 16px 8px;
                        align-self: flex-start;
                    `,
                ],
                "min",
            )}
        `
    },
    rightColumnWrapper: {
        css: css`
            width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`    
                        display: none;
                    `,
                ],
                "min",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`    
                        order: -1;
                    `,
                ],
                "max",
            )}
        `
    },
    bottomWrapper: {
        css: css`
            padding: 16px 24px;
            border-radius: 8px;
            background: ${colorPallete.grey100};
            text-align: center;
            width: 100%;
            align-self: flex-end;
            p, * {
                font: ${labelFonts.label2SemiBold.fontWeight} ${labelFonts.label2SemiBold.fontSize}/${labelFonts.label2SemiBold.lineHeight} ${labelFonts.label2SemiBold.fontFamily}; 
            }
            a {
                text-decoration: underline;
            }
            p {
                margin-bottom: 0;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`    
                        p, * {
                            font-size: ${labelFonts.label1SemiBold.fontSize};
                            line-height: ${labelFonts.label1SemiBold.lineHeight};
                        }
                    `,
                ],
                "min",
            )}
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`    
                        margin: 0 13px;
                        width: calc(100% - 26px);
                        &.hideSectionMobile {
                            display: none;
                        }
                    `,
                ],
                "max",
            )}
        `
    }
};

const styles = coveoSearchPopoverStyles;

interface CoveoSearchPopoverProps1 {
    popoverRef: RefObject<HTMLUListElement>;
    searchInput: ReactElement;
    coveoSearchInputStyles: CoveoSearchInputStyles;
    searchId: string;
    autocompletePositionFunction?: (element: RefObject<HTMLUListElement>) => PositionStyle;
    focusedSearchHistoryQuery?: string;
    query: string;
    showAutocomplete: boolean;
    closeAutocomplete: () => void;
    handleClearSearch: () => void; 
    closePopoverWindow: () => void;
}

type CoveoSearchPopoverProps = CoveoSearchPopoverProps1 & ReturnType<typeof mapStateToProps>;
const DOWN_KEY = 40;
const UP_KEY = 38;

const CoveoSearchPopover = ({
    popoverRef,
    searchInput,
    coveoSearchInputStyles,
    searchId,
    autocompletePositionFunction,
    query,
    coveoCommerce,
    session,
    showAutocomplete,
    searchHistoryEnabled,
    closeAutocomplete,
    handleClearSearch,
    closePopoverWindow,
}: CoveoSearchPopoverProps) => {
    const [focusableAutocompleteItems, setFocusableAutocompleteItems] = useState<Product[]>([]);
    const [focusedAutocompleteItem, setFocusedAutocompleteItem] = useState<Product>();
    const [focusedSearchHistoryQuery, setFocusSearchHistoryQuery] = useState<string>();
    const [activeSuggestionIndex, setActiveSuggestionIndex] = useState<number>(0);
    const {width} = useWindowSize();
    const history = useHistory();
    const dispatch = useDispatch();

    const listRef = useRef<HTMLUListElement>(null);
    const bottomWrapperRef = useRef<HTMLDivElement>(null);

    const [hasBrandSuggestions, setHasBrandSuggestions] = useState(false);
    const brandFilterSuggestions = coveoCommerce?.FilterSuggestionsController?.filterSuggestions?.find(
        (item: any) => item.state.field === "ec_brand"
    );

    useEffect(() => {
        if (!brandFilterSuggestions) return;

        const unsubscribe = brandFilterSuggestions.subscribe(() => {
            const brandValues = brandFilterSuggestions.state.values ?? [];
            setHasBrandSuggestions(brandValues.length > 0);
        });

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [brandFilterSuggestions]);

    const checkSearchHistoryDataExist = searchHistoryEnabled &&  getSearchHistory().length > 0;
    const hasSearchSuggestions = (coveoCommerce?.SearchBoxState?.suggestions?.length ?? 0) > 0;

    const checkLeftColumnContentExist = !(hasBrandSuggestions || hasSearchSuggestions);
 
    let overlayElement:any; let bodyElement:any;

    const updateHeight = () => {
        const productWrapper = document.querySelector('.coveoProductListWrapper') as HTMLElement;
        const container = document.querySelector('.searchContent') as HTMLElement;
        if (container && productWrapper) {
            container.style.minHeight = `${productWrapper.offsetHeight + 100}px`;
        }
    };

    if (typeof document !== "undefined") {
        overlayElement = document.querySelector('.backgroundSearchOverlay');
        bodyElement = document.body;
    }

    let displayItem = false;
    if ((!coveoCommerce?.SearchBoxState?.suggestions || coveoCommerce?.SearchBoxState.suggestions.length === 0) && !hasBrandSuggestions) { 
        displayItem = false;
    } else {
        displayItem = true;
    }

    useEffect(() => {
        if (typeof document === "undefined") {return;}
        const overlayElement = document.querySelector('.backgroundSearchOverlay');
        const bodyElement = document.body;
        if ((!coveoCommerce?.SearchBoxState?.suggestions || coveoCommerce?.SearchBoxState.suggestions.length === 0) && !hasBrandSuggestions) {
            if (overlayElement && bodyElement) {
                overlayElement.classList.add('hidden');
                bodyElement.classList.remove('overlayActive');
            }
        } else if (overlayElement && bodyElement && bodyElement.classList.contains('popoverOpen-headerSearch-popover')) {
              overlayElement.classList.remove('hidden');
              bodyElement.classList.add('overlayActive');
        }
    }, [coveoCommerce?.SearchBoxState?.suggestions, hasBrandSuggestions, showAutocomplete]);

    if((checkLeftColumnContentExist && query.length > 0)) {
        if(width > 1023) {
            closeAutocomplete();
        }
    }

    const handleActiveSuggestionChange = (index: number) => {
        setActiveSuggestionIndex(index);
        setTimeout(() => {
            updateHeight();
        }, 500);
    };

    const normalizeBrandName = (brand: string) => {
        return brand
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    };

    const handleBrandClick = (brand: CategoryFieldSuggestionsValue) => {
        dispatch({
            type: DISPATCH_SET_SEARCH_INPUT_QUERY,
            query: brand.displayValue.toLowerCase(),
        });

        dispatch({
            type: DISPATCH_ISLOADING_UI_STATE,
            query: false
        });

        const normalizedBrand = normalizeBrandName(brand.displayValue);
        history.push(`/brands/${normalizedBrand}`);
    };

    useEffect(() => {
        updateHeight();
        const handleAnchorClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            const clickableElement = target.closest('.bottomWrapperMsg a, .bottomWrapperMsg button');

            if (clickableElement && bottomWrapperRef.current?.contains(clickableElement)) {
                closePopoverWindow();
            }
        };

        document.addEventListener('click', handleAnchorClick);

        return () => {
            document.removeEventListener('click', handleAnchorClick);
        };
    }, []);

    const getPopoverPosition = (element: RefObject<HTMLUListElement>) => {
        if (autocompletePositionFunction) {
            return autocompletePositionFunction(element);
        }

        const positionStyle: PositionStyle = {
            position: "fixed",
        };

        if (element.current) {
            const rect = element.current.getBoundingClientRect();
            const getOverlayElement = document.querySelector('.backgroundSearchOverlay') as HTMLElement;
            positionStyle.top =
                rect.top +
                (rect.height > 100
                    ? sizeVariantValues[coveoSearchInputStyles?.input?.sizeVariant || ("default" as FormFieldSizeVariant)].height
                    : rect.height);
            positionStyle.right = document.documentElement.clientWidth - rect.right;
            if(getOverlayElement) {
                getOverlayElement.style.top = `${positionStyle.top}px`;
            }
            if (window.innerWidth <= 767) {
                positionStyle.top += 30;
            }
        }

        return positionStyle;
    };

    const handlePopoverKeyDown = (event: KeyboardEvent) => {
        switch (event.keyCode) {
            case DOWN_KEY:
                moveFocus("next");
                break;
            case UP_KEY:
                moveFocus("prev");
                break;
            default:
                break;
        }
    };
  
    const moveFocus = throttle((direction: "prev" | "next") => {
        if (query) {
            const focusableQueue =
                direction === "prev" ? focusableAutocompleteItems.slice().reverse() : focusableAutocompleteItems;
            const focusedIndex = focusableQueue.indexOf(focusedAutocompleteItem as Product);
            const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
            setFocusedAutocompleteItem(newFocusedOption);
        } else {
            const searchHistoryItems = getSearchHistory();
            const focusableQueue = direction === "prev" ? searchHistoryItems.slice().reverse() : searchHistoryItems;
            const focusedSearchHistoryItem = focusableQueue.find(o => o.query === focusedSearchHistoryQuery);
            const focusedIndex = focusableQueue.indexOf(focusedSearchHistoryItem as SearchHistoryItem);
            const newFocusedOption = focusableQueue.find((_, index) => index > focusedIndex);
            setFocusSearchHistoryQuery(newFocusedOption?.query);
        }
    }, 100);

    const handlePopoverClose = () => {
        setFocusedAutocompleteItem(undefined);
        setFocusSearchHistoryQuery(undefined);
        if (typeof document !== "undefined") {
            if (overlayElement && bodyElement) {
                overlayElement.classList.add('hidden');
                bodyElement.classList.remove('overlayActive');
            }
        }
    };

    const handlePopoverOpen = () => {
        if (typeof document !== "undefined") {
            const searchContentElement = document.querySelector('.searchContent');
            if (overlayElement && bodyElement) {
                overlayElement.classList.remove('hidden');
                bodyElement.classList.add('overlayActive');
            }
            if ((searchContentElement && searchContentElement.innerHTML.trim() === '') && query.length > 0) {
                if (overlayElement && bodyElement) {
                    overlayElement.classList.add('hidden');
                    bodyElement.classList.remove('overlayActive');
                }
            } 
        }
    }

    return (        
        <>
            <Popover
                {...styles.popover}
                controlsId={`${searchId}-popover`}
                ref={popoverRef}
                insideRefs={[listRef]}
                popoverTrigger={searchInput}
                positionFunction={getPopoverPosition}
                wrapperProps={styles.popoverWrapper}
                contentBodyProps={
                    {
                        ref: listRef,
                        ...styles.popoverContentBody,
                    } as any
                }
                handleKeyDown={handlePopoverKeyDown}
                onClose={handlePopoverClose}
                onOpen={handlePopoverOpen}
            >
                <Hidden above="md">
                    <Button {...styles.cancelButton} className="cancelButtonPopover" onClick={closePopoverWindow}>
                        {translate("Cancel")}
                    </Button>
                </Hidden>
                <StyledWrapper className={`searchContent ${query.length === 0 && !checkSearchHistoryDataExist ? 'hideSection' : ''}`} {...styles.searchContent}>
                    {(showAutocomplete) && (
                        <>
                            {!checkLeftColumnContentExist && (
                                <StyledWrapper {...styles.leftColumnWrapper} className="leftColumnWrapper">
                                    {displayItem && (
                                        <CoveoSearchSuggestions
                                            closeAutocomplete={closeAutocomplete}
                                            onActiveSuggestionChange={handleActiveSuggestionChange}
                                            queryLength={query.length}
                                        />
                                    )}
                                    {(query.length > 0 && (
                                        <CoveoSearchBrands 
                                            closeAutocomplete={closeAutocomplete}
                                            onBrandClick={handleBrandClick}
                                            query={query}
                                        />
                                    ))}
                                    {(query.length === 0 && checkSearchHistoryDataExist) && (
                                        <CoveoSearchHistory
                                            focusedQuery={focusedSearchHistoryQuery}
                                            closeAutocomplete={closeAutocomplete}
                                            extendedStyles={styles.searchHistoryStyles}
                                        />
                                    )}
                                </StyledWrapper>
                            )}
                            {displayItem && (
                                <>
                                    <StyledWrapper {...styles.rightColumnWrapper} className="rightColumnWrapper">
                                        {Array.isArray(coveoCommerce?.SearchBoxState?.suggestions) && coveoCommerce.SearchBoxState.suggestions.length > 0 && (
                                            <CoveoAutocompleteProducts
                                                closeAutocomplete={closeAutocomplete}
                                            />
                                        )}
                                    </StyledWrapper>
                                </>
                             )} 
                        </>
                    )}
                    {((displayItem || hasBrandSuggestions) && !session.isAuthenticated) && (
                        <StyledWrapper {...styles.bottomWrapper} ref={bottomWrapperRef} className={`authenticatedBanner bottomColumnWrapper ${checkLeftColumnContentExist ? 'hideSectionMobile' : ''}`}>
                            <StyledWrapper className="bottomWrapperMsg">
                                {siteMessage("Dsg_CoveoSearchBottomMessage")}
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </StyledWrapper>
            </Popover>
        </>
    );
};

export default connect(mapStateToProps)(CoveoSearchPopover);